export enum MarketplaceIntelligenceWorkspaceCapabilityAccessOperation {
    manageMappings = "ce77887f-6688-4bca-bdf1-f32e7176df3f",
    manageSettings = "b31d50b3-c996-4c47-b036-1401b5fc0135",
    read = "87ca2d0e-8135-4980-91d5-37b5931cd49a",
    triggerSync = "bf1aab6f-77fc-44c0-9143-ed016f4ad700",
}
